export class CCTwoMultiplierEvents {
    public static readonly APPLY_MULTIPLIER: string = "APPLY_MULTIPLIER";
}